import React, { useEffect, useState } from 'react';
import { Form, Select, Spin } from "antd";
import ZenFormInput from '../../pages/InputCreater/ZenFormInput';
import { LoadingOutlined } from '@ant-design/icons';

const GilDropdown = ({
    label,
    labelCol,
    name,
    hasChild,
    childType,
    options,
    defaultValue,
    form,
    children,
    required,
    errorMessage,
    disabled,
    LocalDict = []
}) => {
    const [parentValue, setParentValue] = useState('');
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const [childLoading, setChildLoading] = useState(false);
    useEffect(() => {
        if (defaultValue) {
            setParentValue(defaultValue);
            form.setFieldsValue({ [name]: defaultValue });
            // if (children[defaultValue]?.length) {
            //     children[defaultValue].forEach(x => {
            //         form.setFieldsValue({ [x.data_index]: x.default });
            //     })
            // }
        }
    }, []);

    const changeParentValue = (value) => {
        setChildLoading(true);
        setTimeout(() => {
            setParentValue(value);
            setChildLoading(false);
        }, 500);
        // if(children[value]?.length){
        //     children[value].forEach(x => {
        //         form.setFieldValue(x.data_index, undefined);
        //     })
        // }
    }

    return (
        <div className='gilDropdown'>
            <Form.Item label={label} name={name}
                labelCol={{ span: labelCol || 8 }}
                rules={[
                    {
                        required: required,
                        message: errorMessage,
                    },
                ]}>
                <Select
                    disabled={disabled}
                    onChange={changeParentValue}
                    options={options} />
            </Form.Item>
            {
                childLoading ?
                    <div style={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center', width: '100%', padding: 20 }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} />} />
                    </div> :
                    <>
                        {
                            (children[parentValue] || children[parentValue]?.length) ?
                                children[parentValue].map((x, index) => {

                                    if (dtArray.includes(x["typ"])) {

                                        LocalDict[x["data_index"]] = x["format"]
                                            ? x["format"]
                                            : "YYYY-MM-DD hh:mm:ss";
                                        LocalDict["data_index_from"] = x["data_index_from"];
                                        LocalDict["data_index_to"] = x["data_index_to"];
                                    }
                                    return (
                                        <React.Fragment key={index}>
                                            <ZenFormInput
                                                childType={x.childType}
                                                labelColSpan={x["labelColSpan"]}
                                                style={x['style']}
                                                height={x['height']}
                                                layoutPosition="space-between"
                                                form={form}
                                                rows={x.rows}
                                                colSpan={x.colSize || 12}
                                                name={x["data_index"]}
                                                label={x["label"]}
                                                defaultValue={x["default"]}
                                                typ={x["typ"]}
                                                disabled={x["readOnly"]}
                                                source={x["source"]}
                                                sourceParams={x["sourceParams"]}
                                                auxParams={x["auxParams"]}
                                                format={x["format"]}
                                                errorMessage={x["errorMessage"]}
                                                placeHolder={x["placeHolder"]}
                                                required={x["required"]}
                                                options={x["data"]}
                                                from={x["data_index_from"]}
                                                to={x["data_index_to"]}
                                                url={x["url"]}
                                                includeAll={x["includeAll"]}
                                                pname={x["p_data_index"]}
                                                defaultFrom={x["defaultFrom"]}
                                                defaultTo={x["defaultTo"]}
                                                multiSelect={x["multiSelect"]}
                                                searchable={x["isSearchable"]}
                                                data={x}
                                                // extraData={extraData}
                                                children={x['children']}
                                            />
                                        </React.Fragment>
                                    )
                                }) : <></>
                        }
                    </>
            }

        </div>
    )
};

export default GilDropdown;